import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import BugReportIcon from "@mui/icons-material/BugReport";
import { FilterBar } from "../filterBar";
import { TooltipContainer } from "../tooltipContainer";
import { ReactNode } from "react";
import "./TitleBar.scss";

export const TitleBar = (props: TitleBarProps) => {
  const canTextSearch = props.canTextSearch ?? true;

  const textSearch = (textToSearch: string) => {
    if (!props.textSearch) return;
    props.textSearch(textToSearch);
  };

  const filterButtonClick = () => {
    if (!props.filterButtonClick) return;
    props.filterButtonClick();
  };

  const refreshButtonClick = () => {
    if (!props.refreshButtonClick) return;
    props.refreshButtonClick();
  };

  const toggleInvalidMissionsButtonClick = () => {
    if (!props.toggleInvalidMissionsButtonClick) return;
    props.toggleInvalidMissionsButtonClick();
  };

  const titleText = props.isToggleInvalidMissionsActivated
    ? `${props.title} with invalid missions`
    : props.title;

  return (
    <div className={`col-12 title-bar-container ${props.className ?? ""}`}>
      {/* Without the search slot the grid would place the actions in the column reserved
          for it, leaving them stranded in the middle of the bar. */}
      <div
        className={`title-bar-layout py-2 px-2${
          canTextSearch ? "" : " title-bar-layout--no-search"
        }`}
      >
        <div className="title-bar-layout__title">
          <span className="title">{titleText}</span>
        </div>

        {canTextSearch && (
          <div className="title-bar-layout__search">
            {props.textSearchToolTip ? (
              <TooltipContainer text={props.textSearchToolTip}>
                <FilterBar search={textSearch} />
              </TooltipContainer>
            ) : (
              <FilterBar search={textSearch} />
            )}
          </div>
        )}

        {(props.canFilterButton ||
          props.canRefreshButton ||
          props.canToggleInvalidMissionsButton ||
          props.actions) && (
          <div className="title-bar-layout__actions">
            {props.actions}
            {props.canFilterButton && (
              <TooltipContainer text={props.filterButtonToolTip ?? ""}>
                <FilterAltOutlinedIcon
                  className="icon-button"
                  onClick={filterButtonClick}
                />
              </TooltipContainer>
            )}
            {props.canRefreshButton && (
              <TooltipContainer text={props.refreshButtonToolTip ?? ""}>
                <RefreshRoundedIcon
                  className="icon-button"
                  onClick={refreshButtonClick}
                />
              </TooltipContainer>
            )}
            {props.canToggleInvalidMissionsButton && (
              <TooltipContainer
                text={props.toggleInvalidMissionsButtonToolTip ?? ""}
              >
                <BugReportIcon
                  className={
                    props.isToggleInvalidMissionsActivated
                      ? "icon-button-active"
                      : "icon-button"
                  }
                  onClick={toggleInvalidMissionsButtonClick}
                />
              </TooltipContainer>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export interface TitleBarProps {
  title: string;
  className?: string;
  actions?: ReactNode;
  canTextSearch?: boolean;
  textSearchToolTip?: string | null;
  textSearch?: (textToSearch: string) => void;
  canFilterButton?: boolean;
  filterButtonToolTip?: string | null | undefined;
  filterButtonClick?: () => void;
  canRefreshButton?: boolean;
  refreshButtonToolTip?: string | null | undefined;
  refreshButtonClick?: () => void;
  canToggleInvalidMissionsButton?: boolean;
  toggleInvalidMissionsButtonToolTip?: string | null | undefined;
  toggleInvalidMissionsButtonClick?: () => void;
  isToggleInvalidMissionsActivated?: boolean;
}
